import { SocialIcons, useCustomClassContext } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { SocialIconProps } from "packages/design-system/src/components/Block/SocialIcon/SocialIcon";
import { ReactNode } from "react";

import styles from "./socialmedia.module.css";

type SocialMediaProps = {
  data: SocialIconProps;
  title?: string;
  showOnly?: "mobile" | "desktop";
  isAlternateIconColor?: boolean;
};

export default function SocialMedia({
  title,
  data,
  showOnly,
  isAlternateIconColor,
}: SocialMediaProps): ReactNode {
  const customClass = useCustomClassContext();

  return (
    !!data.icons.length && (
      <div
        className={cx(
          styles.socialIconsBox,
          showOnly && styles[showOnly],
          isAlternateIconColor
            ? customClass?.socialMedia?.altContainer
            : customClass?.socialMedia?.container,
        )}
      >
        {title && <p className={styles.socialIconDesc}>{title}</p>}

        <SocialIcons {...data} />
      </div>
    )
  );
}
